import { render, staticRenderFns } from "./AppHeaderTab.vue?vue&type=template&id=0fd248c2&scoped=true&"
import script from "./AppHeaderTab.vue?vue&type=script&lang=ts&"
export * from "./AppHeaderTab.vue?vue&type=script&lang=ts&"
import style0 from "./AppHeaderTab.vue?vue&type=style&index=0&id=0fd248c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd248c2",
  null
  
)

export default component.exports